import React, { useContext } from "react";

import ContentContext from "../../contexts/ContentContext";
import ContentAdminCasts from "./casting/ContentAdminCasts";

function TabContentCasting() {
  const { item, isDisabled, onItemUpdate } = useContext(ContentContext);

  const handleCastingUpdate = (castings) => {
    onItemUpdate({
      ...item,
      medias_castings: castings,
    });
  };

  return (
    <div id="castingAnchor">
      <ContentAdminCasts
        isDisabled={isDisabled}
        mediaCastings={item.medias_castings}
        onUpdateCasting={handleCastingUpdate}
      />
    </div>
  );
}

export default TabContentCasting;
